import React from 'react';

const TextAreaInput = ({ label, placeholder, value, onChange, error, style }) => {
	return (
		<div className='modal_text-input'>
			<label htmlFor={label} className='modal_input--label'>
				{label}
			</label>
			<textarea
				id={label}
				placeholder={placeholder}
				value={value}
				onChange={(e) => onChange(e)}
				className='modal_input--textarea'
				style={style}
			/>
			{error && <p className='error_message'>{error}</p>}
		</div>
	);
};

export default TextAreaInput;
